import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import { FilterInput } from '../../common/filterInput'
import { cellStyles, headCellStyles, paymentTypeStyles, excelHeadCellStyles } from './const'
import { getPaymentTypeBackground } from '../../common/helper'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { columnDefsThree } from './DeliveryMemoTableDefs'
import { useAtom } from 'jotai'
import React from 'react'
import { sourceCityAtom, destinationCityAtom } from '../../common/jotaiState/deliverymemoStateAtoms'

const DeliveryMemoTableThree = (props) => {
  const {appliedMoreFilter, tableData,  loginData, memoFromDate, memoToDate,showMore } = props
  const theme = useTheme()
  const { palette: cs } = theme
  const [filterValues, setFilterValues] = useState({});
  const [filteredData, setfilteredData] = useState(tableData)
  const [sourceCity] = useAtom(sourceCityAtom)
  const [destinationCity] = useAtom(destinationCityAtom) 
  useEffect(() => {
    let newData=tableData.sort((a,b)=>{
      const dateA = (new Date(a.ReceiptDateOriginal))
      const dateB = new Date(b.ReceiptDateOriginal)
        return dateB - dateA
    })
    setfilteredData(newData)
  }, [tableData])
  const handleChangeContain = (e, name) => {
    let value = e.target.value;
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value
    }));
  }
  useEffect(() => {
    const filteredDataTemp = tableData.filter((item) => {
      return columnDefsThree.every((column) => {
        const filterValue = filterValues[column.field] || "";
        const value = item[column.field]
        return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
      })
    })
    setfilteredData(filteredDataTemp)
  }, [filterValues])
  return (
    <>
    
      <TableContainer className="delivery-memo-table scroll"
        component={Paper}
        sx={{border:'1px solid #aeaeae', borderRadius: '8px', height: showMore?'calc( 66vh - 160px)':'calc( 85vh - 150px)', overflow: 'auto', margin:'0px 0px 0px 5px' }}
      >
        <Table aria-label="a dense table" id='delivery-memo-tbl-three'>
          <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', zIndex: 2 }}>
            <TableRow>
              <TableCell style={{ ...headCellStyles, width: '7%', backgroundColor: '#0086ff' }}>LR<br />Number</TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', backgroundColor: '#0086ff' }}>Offline<br />LR No</TableCell>
              <TableCell style={{ ...headCellStyles, width: '4%', backgroundColor: '#0086ff' }}>Payment<br />Type</TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%', backgroundColor: '#0086ff' }}>Source<br />City</TableCell>
              <TableCell style={{ ...headCellStyles, width: '7%', backgroundColor: '#0086ff' }}>Destination<br />City</TableCell>
              <TableCell style={{ ...headCellStyles, width: '9%', backgroundColor: '#0086ff' }}>Destination<br />Branch</TableCell>
              <TableCell style={{ ...headCellStyles, width: '8%', backgroundColor: '#0086ff' }}>Current<br />Branch</TableCell>
              <TableCell style={{ ...headCellStyles, width: '5%', backgroundColor: '#0086ff' }}>Receive<br />Date</TableCell>
              <TableCell style={{ ...headCellStyles, width: '4%', backgroundColor: '#0086ff' }}>Total<br />Units</TableCell>
              <TableCell style={{ ...headCellStyles, width: '3.5%', backgroundColor: '#0086ff' }}>LR Due<br />Amount</TableCell>
              <TableCell style={{ ...headCellStyles, width: '8%', backgroundColor: '#0086ff' }}>Other Branch<br />Incharge Name </TableCell>
              <TableCell style={{ ...headCellStyles, width: '9%', backgroundColor: '#0086ff' }}>Branch Incharge<br />Contact Number</TableCell>
              <TableCell style={{ ...headCellStyles, width: '9%', backgroundColor: '#0086ff' }}>Received By<br />Vehicle Number</TableCell>
              <TableCell style={{ ...headCellStyles, width: '8.5%', backgroundColor: '#0086ff', borderTopRightRadius: '8px' }}> Driver Number -<br />Name</TableCell>
            </TableRow>
            <TableRow style={{ position: 'sticky', top: '0', zIndex: 3, background: '#fff' }}>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'LRNO') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'ManualLRNo') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'PaymentType') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'SourceCity') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'DestinationCity') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'DestinationBranch') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'CurrentBranch') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'ReceiptDate') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'Units') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'TotalDues') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'OtherBranchInchargeName') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'OtherBranchIncContactNo') }} />
                </Box>
              </TableCell>

              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'VehicleNo') }} />
                </Box>
              </TableCell>
              <TableCell style={cellStyles}>
                <Box>
                  <FilterInput label="Contains" marginB={true} onChange={(e) => { handleChangeContain(e, 'DriverName') }} />
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData?.map((el, index) => (
              <DeliveryMemoRow key={'table-memo' + index} index={index} data={el} cs={cs} loginData={loginData} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer
        component={Paper}
        sx={{ borderRadius: '8px', border: '0px solid #ccc', height: 'calc( 66vh - 100px)', overflow: 'auto', display: 'none' }}
      >
        <Table aria-label="a dense table" id='delivery-memo-excel-tbl'>
          <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
            <TableRow>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontSize:'18px' }}> Delivery Memo: Pending My Delivery At Other Branch</h3>
              </TableCell>
              <TableCell
                className="reportTD"
                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left' }}
                colSpan={7}
              >
                <h3 style={{ paddingLeft: '17px', fontSize:'18px' }}>Company Name : {loginData.strCompanyName}</h3>
              </TableCell>
            </TableRow>
            <TableRow ><TableCell colSpan={14}></TableCell></TableRow>
            <TableRow style={{ color: '#444444' }}>
              <TableCell className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={4}
              >
                From Memo Date
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                To Memo Date
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={4}
              >
                Source City
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={4}
              >
                Destination City
              </TableCell>
            </TableRow>
            <TableRow >
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={4}
              >
                {moment(memoFromDate).format("DD-MM-YYYY")}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {moment(memoToDate).format("DD-MM-YYYY")}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={4}
              >
                {sourceCity.map((item) => item.sourceCityList).join(', ')}
              </TableCell>
              <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={4}
              >
                {destinationCity.destinationCityName}
              </TableCell>
            </TableRow>
            <TableRow ><TableCell colSpan={14}></TableCell></TableRow>
            <TableRow style={{ color: '#444444' }}>
              {appliedMoreFilter?.hasOwnProperty('PaymentType') && <TableCell className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Payment Type
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ChallanNo') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Challan No
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('LRNO') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                LR No
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ManualLRNo') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Offline LR No
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('Sender') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={3}
              >
                Sender
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderMobileNo') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Sender No
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderGSTN') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Sender GSTIN
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderEmailID') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Sender Email ID
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('RecName') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('RecMobileNo') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver No
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ReceiverEmailID') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver Email ID
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ReceiverGSTN') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Receiver GSTIN
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('PinCode') && <TableCell
                className="ReportItemHead"
                style={{ fontWeight: 'bold', backgroundColor: '#0086FF', color: '#444444', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc' }}
                colSpan={2}
              >
                Pincode
              </TableCell>}
            </TableRow>

            <TableRow style={{ color: '#444444' }}>
              {appliedMoreFilter?.hasOwnProperty('PaymentType') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.PaymentType}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ChallanNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.ChallanNo}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('LRNO') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.LRNO}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ManualLRNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.ManualLRNo}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('Sender') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={3}
              >
                {appliedMoreFilter?.Sender}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderMobileNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.SenderMobileNo}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderGSTN') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.SenderGSTN}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('SenderEmailID') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.SenderEmailID}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('RecName') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.RecName}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('RecMobileNo') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.RecMobileNo}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ReceiverEmailID') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.ReceiverEmailID}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('ReceiverGSTN') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.ReceiverGSTN}
              </TableCell>}
              {appliedMoreFilter?.hasOwnProperty('PinCode') && <TableCell
                className="ReportItemHead"
                style={{
                  fontWeight: 'bold', color: 'black', fontSize: '16px', 
                  fontWeight: '600', fontFamily: 'Roboto',  textAlign: 'left', borderRight: '1px solid #ccc'
                }}
                colSpan={2}
              >
                {appliedMoreFilter?.PinCode}
              </TableCell>}
            </TableRow>
            <TableRow ><TableCell colSpan={14}></TableCell></TableRow>
          </TableHead>
          <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', zIndex: 2 }}>
            <TableRow>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '7%', backgroundColor: '#0086ff' }}>LR<br />Number</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '5%', backgroundColor: '#0086ff' }}>Offline<br />LR No</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '4%', backgroundColor: '#0086ff' }}>Payment<br />Type</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '7%', backgroundColor: '#0086ff' }}>Source<br />City</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '7%', backgroundColor: '#0086ff' }}>Destination<br />City</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '9%', backgroundColor: '#0086ff' }}>Destination<br />Branch</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '9%', backgroundColor: '#0086ff' }}>Current<br />Branch</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '5%', backgroundColor: '#0086ff' }}>Receive<br />Date</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'right', width: '4%', backgroundColor: '#0086ff' }}>Total<br />Units</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'right', width: '3%', backgroundColor: '#0086ff' }}>LR Due<br />Amount</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '8%', backgroundColor: '#0086ff' }}>Other Branch<br />Incharge Name </TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '8%', backgroundColor: '#0086ff' }}>Branch Incharge<br />Contact Number</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '8%', backgroundColor: '#0086ff' }}>Received By<br />Vehicle Number</TableCell>
              <TableCell style={{ ...excelHeadCellStyles, fontSize: '16px', textAlign:'left', width: '10%', backgroundColor: '#0086ff', borderTopRightRadius: '8px' }}> Driver Number -<br />Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData?.map((data, index) => (
              <TableRow key={`memo-tbl-three-${index}`}>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd', textAlign:'left' }} >
                  <Typography> {`\u200B${data.LRNO}`}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography> {`\u200B${data?.ManualLRNo}`}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <div style={{ ...paymentTypeStyles }} ><span style={{ backgroundColor: getPaymentTypeBackground(data?.PaymentType), padding: '4px 9px', borderRadius: '30px',fontSize:'16px', textDecoration: data?.PaymentType?.length > 7 ? 'underline' : '' }} title={data?.PaymentType}>{data?.PaymentType}</span></div>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography>{data?.SourceCity}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography>{data?.DestinationCity}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography>{data?.DestinationBranch!==loginData?.strBranchName?loginData?.strBranchName:data?.DestinationBranch}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography >{data?.CurrentBranch}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography >{data.ReceiptDate}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography style={{ textAlign: 'right' }}>{data.Units}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography style={{ textAlign: 'right' }}>{data.TotalDues}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography >{data.OtherBranchInchargeName}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography >{data.OtherBranchIncContactNo}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography >{data.VehicleNo}</Typography>
              </TableCell>
              <TableCell style={{ ...cellStyles, fontSize: '16px',  border: 'none', borderBottom: '1px solid #ddd' }}>
                  <Typography >{data.DriverName} </Typography>
                  <Typography >{data.DriverContactNo} </Typography>
              </TableCell>
            </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </>
  )
}
const DeliveryMemoRow = (props) => {
  const { cs, index, data, loginData } = props
  return (
    <TableRow>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }} >
        <Box>
          <Typography>{data?.LRNO}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography>{data?.ManualLRNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <div style={{ ...paymentTypeStyles }} ><span style={{ backgroundColor: getPaymentTypeBackground(data?.PaymentType), padding: '4px 9px', borderRadius: '30px', textDecoration: data?.PaymentType?.length > 7 ? 'underline' : '' }} title={data?.PaymentType}>{data?.PaymentType}</span></div>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography>{data?.SourceCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography>{data?.DestinationCity}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography>{data?.DestinationBranch!==loginData?.strBranchName?loginData?.strBranchName:data?.DestinationBranch}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography >{data?.CurrentBranch}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography >{data.ReceiptDate}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography style={{ textAlign: 'right' }}>{data.Units}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography style={{ textAlign: 'right' }}>{data.TotalDues}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography >{data.OtherBranchInchargeName}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography >{data.OtherBranchIncContactNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography >{data.VehicleNo}</Typography>
        </Box>
      </TableCell>
      <TableCell style={{ ...cellStyles, border: 'none', borderBottom: '1px solid #ddd' }}>
        <Box>
          <Typography >{data.DriverName} </Typography>
          <Typography >{data.DriverContactNo} </Typography>
        </Box>
      </TableCell>
    </TableRow>
  )
}
export default DeliveryMemoTableThree
